import { h, Host } from "@stencil/core";
export class Sidebar {
    constructor() {
        this.name = "";
        this.closeOnEscKey = false;
        this.closeOnBackdropClick = true;
        this.transition = "slide";
        this.alignment = "right";
        this.disableBackdrop = false;
        this.disableCloseIcon = false;
        this.alignHeader = false;
        this.alignFooter = false;
        this.zIndex = 4001;
        this.opened = false;
    }
    baseClass = "ux-sidebar";
    domNode;
    /** Emitted when the sidebar is opened or closed */
    sidebarVisibilityChanged;
    /** Toggles sidebar open or closed */
    async toggleSidebar() {
        const newOpenState = !this.opened;
        const evt = this.sidebarVisibilityChanged.emit({
            name: this.name,
            opened: newOpenState
        });
        if (!evt.defaultPrevented) {
            this.opened = newOpenState;
        }
    }
    /** Listen for escape key  */
    handleKeyDown(event) {
        if (this.closeOnEscKey && this.opened && event.key === "Escape") {
            this.toggleSidebar();
        }
    }
    triggerElementClickHandler = (e) => {
        const targetElement = e.target.closest("[data-trigger-sidebar]");
        if (targetElement === null) {
            return;
        }
        // Extract commands from the event, filtering for this sidebar
        const commands = (targetElement.getAttribute("data-trigger-sidebar") || "")
            .split(";")
            .map((string) => string.split(","))
            .filter(([, name]) => name === this.name);
        if (commands.length > 0) {
            this.toggleSidebar();
        }
    };
    componentDidLoad() {
        document.addEventListener("click", this.triggerElementClickHandler);
    }
    disconnectedCallback() {
        document.removeEventListener("click", this.triggerElementClickHandler);
    }
    render() {
        const handleClickClose = () => {
            this.toggleSidebar();
        };
        return (h(Host, { key: 'b6be7a368f1d5d79b34a104918182d9eca85b283', class: {
                [this.baseClass]: true,
                [`${this.baseClass}--open`]: this.opened
            } }, this.disableBackdrop ? null : (h("div", { class: {
                [`${this.baseClass}__backdrop`]: true,
                [`${this.baseClass}__backdrop--no-transition`]: this.transition === "none"
            },
            // @ts-expect-error Check for typing
            onClick: this.closeOnBackdropClick ? handleClickClose : null, style: { zIndex: `${this.zIndex}` } })), h("div", { key: '67120ae21309e427d1d87df6e20f3004ea5df2e9', class: {
                [`${this.baseClass}__inner`]: true,
                [`${this.baseClass}__inner--no-transition`]: this.transition === "none",
                [`${this.baseClass}__inner--align-left`]: this.alignment === "left",
                [`${this.baseClass}__inner--align-header`]: this.alignHeader,
                [`${this.baseClass}__inner--align-footer`]: this.alignFooter
            } }, this.disableCloseIcon ? null : (h("div", { class: `${this.baseClass}__head` }, h("button", { type: "button", class: `${this.baseClass}__close`, onClick: handleClickClose }, h("ux-icon", { name: "cross", weight: "bold" })))), h("div", { key: 'ad86c3cbcb40d4db7ccb4b46d8039f5ecbce3df0', class: `${this.baseClass}__slot` }, h("slot", { key: 'f770ca4ff48076c788c61f62413960c1778caa26' })))));
    }
    static get is() { return "ux-sidebar"; }
    static get originalStyleUrls() {
        return {
            "$": ["sidebar.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["sidebar.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set the name of the sidebar"
                },
                "attribute": "name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "closeOnEscKey": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If present, uxSidebarVisibilityChanged event is emitted when escape key is pressed *"
                },
                "attribute": "close-on-esc-key",
                "reflect": false,
                "defaultValue": "false"
            },
            "closeOnBackdropClick": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If present, uxSidebarVisibilityChanged event is emitted when the backdrop is clicked *"
                },
                "attribute": "close-on-backdrop-click",
                "reflect": false,
                "defaultValue": "true"
            },
            "transition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"slide\" | \"none\"",
                    "resolved": "\"none\" | \"slide\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Toggle transition *"
                },
                "attribute": "transition",
                "reflect": false,
                "defaultValue": "\"slide\""
            },
            "alignment": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"right\" | \"left\"",
                    "resolved": "\"left\" | \"right\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set alignment of sidebar *"
                },
                "attribute": "alignment",
                "reflect": false,
                "defaultValue": "\"right\""
            },
            "disableBackdrop": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disable backdrop *"
                },
                "attribute": "disable-backdrop",
                "reflect": false,
                "defaultValue": "false"
            },
            "disableCloseIcon": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disable header with close icon *"
                },
                "attribute": "disable-close-icon",
                "reflect": false,
                "defaultValue": "false"
            },
            "alignHeader": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the sidebar top should be aligned with a header"
                },
                "attribute": "align-header",
                "reflect": false,
                "defaultValue": "false"
            },
            "alignFooter": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the sidebar bottom should be aligned with a footer"
                },
                "attribute": "align-footer",
                "reflect": false,
                "defaultValue": "false"
            },
            "zIndex": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Define z-index of backdrop"
                },
                "attribute": "z-index",
                "reflect": false,
                "defaultValue": "4001"
            },
            "opened": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Boolean to indicate if or not the sidebar is currently opened"
                },
                "attribute": "opened",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "sidebarVisibilityChanged",
                "name": "uxSidebarVisibilityChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the sidebar is opened or closed"
                },
                "complexType": {
                    "original": "{ name: string; opened: boolean }",
                    "resolved": "{ name: string; opened: boolean; }",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "toggleSidebar": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Toggles sidebar open or closed",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "domNode"; }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "handleKeyDown",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=sidebar.js.map
